@if (!summary) {
  <fieldset>
    <legend>
      @if (!hideLabels) {
        <label [innerHtml]="question?.editLabel | localized"></label>
      }
    </legend>
    <mat-radio-group [formControl]="control"
      [value]="control?.value"
      [required]="question?.isRequired"
      [id]="question?.questionNumber"
      (change)="onModelChange()">
      <mat-radio-button [value]="'True'">
        <span>{{'inscription.form.yes' | translate}}</span>
      </mat-radio-button>
      <mat-radio-button [value]="'False'">
        <span>{{'inscription.form.no' | translate}}</span>
      </mat-radio-button>
    </mat-radio-group>
    @if (!control.valid && control.touched) {
      <mat-error>
        {{'form.validation.required' | translate}}
      </mat-error>
    }
  </fieldset>
}

@if (summary) {
  <p
    class="summary">
    @if (!hideLabels) {
      <label [innerHtml]="question?.summaryLabel | localized"> : </label>
    }
    @if (control?.value === 'True') {
      <span>{{'inscription.form.yes' | translate}}</span>
    }
    @if (control?.value === 'False') {
      <span>{{'inscription.form.no' | translate}}</span>
    }
    @if (!control?.value) {
      <span
      class="notFilled">N/A</span>
    }
  </p>
}